import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideMatomo, withRouter } from 'ngx-matomo-client';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { dbConfig } from './app/db.config';
import { importProvidersFrom } from '@angular/core';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import { IndexedDbService } from './app/services/indexed-db.service';
import { NetworkService } from './app/services/network.service';
import { User } from './app/models/user';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';
import { StorageService } from './app/services/storage.service';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicSharedModule } from './app/ionic-shared.module';
import { HttpErrorInterceptor } from './app/http-error.interceptor';
import { provideHttpClient, withFetch } from "@angular/common/http";
import { IonicModule } from '@ionic/angular';
import { fadeTransition } from './app/fade-transition';
import { environment } from './environments/environment';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import { register } from 'swiper/element/bundle';
register()

bootstrapApplication(AppComponent, {
  providers: [
    provideMatomo(
      {
        disabled: false,
        siteId: environment.APP_VERSION == 'SonEspaceEleveur' ? 5: 4,
        trackerUrl: 'https://matomo.canicompet.com',
      },
      withRouter(),
    ),
    importProvidersFrom(IonicModule),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    importProvidersFrom(NgxIndexedDBModule.forRoot(dbConfig)),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideIonicAngular({mode: 'ios', navAnimation: fadeTransition}),
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(IonicStorageModule.forRoot()),
    importProvidersFrom(IonicSharedModule),{
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    provideHttpClient(withFetch()),
    IndexedDbService, NetworkService, StorageService,
    importProvidersFrom(
      HttpClientModule,  // Nécessaire pour la communication HTTP
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    )
  ],
}).then(appRef => {
  const translateService = appRef.injector.get(TranslateService);
  translateService.setDefaultLang('fr');
});
